import React from 'react';
interface ScrollTableProps {
  children: React.ReactNode;
  className?: string;
}
export function ScrollTable({
  children,
  className = ''
}: ScrollTableProps) {
  return <div className={className} data-id="element-263" data-mp="1fyv9sdpedgb7">
      <p className="md:hidden text-center text-xs text-warmgray mb-2" data-id="element-264" data-mp="1fzn7bu2k1o44">
        ← Scroll to see full table →
      </p>
      <div className="overflow-x-auto rounded-2xl border border-gold-aged/40 bg-white shadow-[0_4px_20px_rgba(18,53,36,0.08)]" data-id="element-265" data-mp="1k18fx3823g8i">
        <table className="w-full min-w-[520px] text-left text-sm" data-id="element-266" data-mp="27s4cserdd1mm">
          {children}
        </table>
      </div>
    </div>;
}